module.exports = __webpack_public_path__ + "img/gift.9502cac.svg?v=1764903765445";